module.exports = __webpack_public_path__ + "static/media/cloud-checkmark.43178a4c.svg";